<template>
  <div class="nav-tabs-wrapper">
    <ul class="nav nav-tabs" role="tablist">
      <li v-for="item in navItems" class="nav-item" :key="item">
        <a
          class="nav-link"
          :class="{
            active: localActive === item,
          }"
          :href="`#${slugify(item)}`"
          @click.prevent="localActive = item; $dispatch('change', item)"
        >
          {{ item }}
        </a>
      </li>
    </ul>
    <div class="tab-content">
      <div
        v-for="item in navItems"
        :key="item"
        class="tab-pane"
        :class="{
          active: localActive === item,
          show: localActive === item,
        }"
        role="tabpanel"
        :aria-labelledby="`${slugify(item)}-tab`"
      >
        <slot :name="slugify(item)">
          {{slugify(item)}}
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
  import slugify from 'slugify'
  export default{
    props:{
      navItems: { type: Array, required: true },
      active: { type: String, default:null
      }
    },
    data(){
      return {
        localActive: ''
      }
    },
    methods:{
      slugify(string){
        return slugify(string).toLowerCase()
      }
    },
    watch:{
      active(active){
        this.localActive = active
      }
    },
    created(){
      this.localActive = this.active || this.navItems[0]
    }
  }
</script>
<style scoped>
  .nav-tabs-wrapper{
    padding: 10px 0;
  }
  .tab-content{
    padding:10px 0;
  }
</style>
